
import { AppNotification } from '@/store/notifications/types'
import { Component, Vue } from 'vue-property-decorator'
import AppAnnouncementDismissMenu from './AppAnnouncementDismissMenu.vue'

@Component({
  components: {
    AppAnnouncementDismissMenu
  }
})
export default class AppNotificationMenu extends Vue {
  menu = false

  get notifications (): AppNotification[] {
    return this.$store.getters['notifications/getNotifications']
  }

  get notificationsCounter (): number {
    const notifications: AppNotification[] = this.notifications.filter(n => !n.noCount)
    return notifications.length
  }

  get clearableNotifications (): AppNotification[] {
    const notifications: AppNotification[] = this.$store.getters['notifications/getNotifications']
    return notifications.filter(n => n.clear)
  }

  /**
   * Color is determined by type. Pull the highest weighted type.
   */
  get color () {
    if (this.notifications.length <= 0) return 'transparent'
    let c = 'transparent'
    for (const n of this.notifications) {
      if (n.type === 'warning' && c !== 'error') c = 'warning'
      if (n.type === 'error' && c !== 'error') {
        c = 'error'
        break
      }
    }
    return c
  }

  get badgeColor () {
    if (this.color === 'transparent') return 'info'
    return this.color
  }

  get isMobile () {
    return this.$vuetify.breakpoint.mobile
  }

  /**
   * If no defined icon, pull from a standard set based on notification type.
   */
  icon (n: AppNotification) {
    if (n.icon) return n.icon
    switch (n.type) {
      case 'info':
      case 'success':
      case 'announcement':
        return '$info'
      case 'warning':
        return '$warning'
    }
    return '$error'
  }

  classes (n: AppNotification) {
    return `notification-${n.type}`
  }

  handleClear (n: AppNotification) {
    this.$store.dispatch('notifications/clearNotification', n)
  }

  handleClearAll () {
    this.$store.dispatch('notifications/clearAll')
  }

  handleAnnouncementDismiss (n: AppNotification, wake_time: number) {
    if (n && wake_time) {
      this.$store.dispatch('announcements/dismiss', {
        entry_id: n.id,
        wake_time
      })

      this.menu = false
    }
  }
}
